import * as r from "react";
import { useUID as d } from "@twilio-paste/uid-library";
import { IconWrapper as m } from "./helpers/IconWrapper";
const n = r.forwardRef((_ref, a) => {
  let {
    as: c,
    display: l,
    element: i = "ICON",
    size: p,
    color: t,
    title: e,
    decorative: o
  } = _ref;
  const s = `SuccessIcon-${d()}`;
  if (!o && e == null) throw new Error("[SuccessIcon]: Missing a title for non-decorative icon.");
  return r.createElement(m, {
    as: c,
    display: l,
    element: i,
    size: p,
    color: t,
    ref: a
  }, r.createElement("svg", {
    role: "img",
    "aria-hidden": o,
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    "aria-labelledby": s
  }, e ? r.createElement("title", {
    id: s
  }, e) : null, r.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm2.997 5c-.266 0-.521.106-.71.294l-3.286 3.294L7.712 9.29a1.003 1.003 0 00-1.418 1.418l1.998 1.997a1 1 0 001.418 0l3.996-3.994A1.002 1.002 0 0012.996 7z"
  })));
});
n.displayName = "SuccessIcon";
export { n as SuccessIcon };